/* eslint-disable no-case-declarations */

import {
  FINDING_SETTLEMENTS,
  FINDING_SETTLEMENTS_SUCCESS,
  FINDING_SETTLEMENTS_ERROR,

} from '../actions/settlements';

const initialState = {
  advertiseList: [],
  settlement_total: 0,
  loading: false,
  find_settlement_loading: false,
};
  
const SettlementsReducer = (state = initialState, action) => {
    switch (action.type) {

      case FINDING_SETTLEMENTS:
        return { ...state, find_settlement_loading: true };
  
      case FINDING_SETTLEMENTS_SUCCESS:
        return {
          ...state,
          find_settlement_loading: false,
          settlement_total: action.payload.find_total,
          advertiseList: action.payload.find_advertises,
        };
  
      default:
        return state;
    }
  };
  
  export default SettlementsReducer;
  